import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { IResponse } from 'src/models/response.model';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private readonly _apiUrl: string;

  constructor(private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    @Inject(PLATFORM_ID) private platformId: Object,
    private logger: NGXLogger) {
    this._apiUrl = baseUrl + 'api/Product';
  }

  search(prodName: string) {
    let param = { prodName: '' };
    if (!!prodName) param.prodName = prodName;  // null undefined가 아닌 경우만 기능하도록
    return this.http.get(this._apiUrl, { params: param })
      .pipe(
        tap(data => this.logger.log('search', data)),
        catchError(err => {
          this.logger.error(err);
          return throwError(err);
        }),
        map((res: IResponse) => res.result),
      );
  }

  retrieveAll() {
    return this.http.get(this._apiUrl)
      .pipe(
        tap(data => this.logger.log('retrieveAll', data)),
        catchError(err => {
          this.logger.error(err);
          return throwError(err);
        }),
        map((res: IResponse) => res.result),
      );
  }
}

export interface IProduct {
  itemID: string,
  itemName: string,
}